/**
 * Generated from hh_ch1_p08.fla
 */
export function hh_ch1_p08(this: Ihh_ch1_p08) {
	const hollyBack = this.hollyBack;
	if (!hollyBack[0] && hollyBack.elementFactory) {
		hollyBack[0] = hollyBack.elementFactory(0,undefined);
	}
	if (hollyBack[0]) {
		hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback.call(hollyBack[0] as Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback);
		hollyBack[0].x = 1045;
		hollyBack[0].y = 215.75;
		hollyBack[0].width = 488.50;
		hollyBack[0].height = 603.50;
		hollyBack[0].alpha = 1;
		if (hollyBack[0].onLayout) hollyBack[0].onLayout();
	}
	if (!hollyBack[1] && hollyBack.elementFactory) {
		hollyBack[1] = hollyBack.elementFactory(1,undefined);
	}
	if (hollyBack[1]) {
		hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback.call(hollyBack[1] as Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback);
		hollyBack[1].x = 878;
		hollyBack[1].y = 328.75;
		hollyBack[1].width = 488.50;
		hollyBack[1].height = 603.50;
		hollyBack[1].alpha = 1;
		if (hollyBack[1].onLayout) hollyBack[1].onLayout();
	}
	const hollyFront = this.hollyFront;
	if (!hollyFront[0] && hollyFront.elementFactory) {
		hollyFront[0] = hollyFront.elementFactory(0,undefined);
	}
	if (hollyFront[0]) {
		hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront.call(hollyFront[0] as Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront);
		hollyFront[0].x = 1108.5;
		hollyFront[0].y = 111.5;
		hollyFront[0].width = 50.00;
		hollyFront[0].height = 129.00;
		hollyFront[0].alpha = 1;
		if (hollyFront[0].onLayout) hollyFront[0].onLayout();
	}
	if (!hollyFront[1] && hollyFront.elementFactory) {
		hollyFront[1] = hollyFront.elementFactory(1,undefined);
	}
	if (hollyFront[1]) {
		hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront.call(hollyFront[1] as Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront);
		hollyFront[1].x = 941.5;
		hollyFront[1].y = 224.5;
		hollyFront[1].width = 50.00;
		hollyFront[1].height = 129.00;
		hollyFront[1].alpha = 1;
		if (hollyFront[1].onLayout) hollyFront[1].onLayout();
	}
	const frame = this.frame;
	if (!frame[0] && frame.elementFactory) {
		frame[0] = frame.elementFactory(0,undefined);
	}
	if (frame[0]) {
		hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframech1_p6_wcframe.call(frame[0] as Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframech1_p6_wcframe);
		frame[0].x = 832;
		frame[0].y = 384;
		frame[0].width = 1664.00;
		frame[0].height = 768.00;
		frame[0].alpha = 1;
		if (frame[0].onLayout) frame[0].onLayout();
	}
	if (!frame[1] && frame.elementFactory) {
		frame[1] = frame.elementFactory(1,undefined);
	}
	if (frame[1]) {
		hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframeLayer196.call(frame[1] as Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframeLayer196);
		frame[1].x = 832;
		frame[1].y = 384;
		frame[1].width = 1664.00;
		frame[1].height = 768.00;
		frame[1].alpha = 1;
		if (frame[1].onLayout) frame[1].onLayout();
	}
	const background = this.background;
	hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_background.call(this.background);
	background.x = 832;
	background.y = 384;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const kitchen = this.kitchen;
	hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_kitchen.call(this.kitchen);
	kitchen.x = 192.75;
	kitchen.y = 413.75;
	kitchen.width = 385.50;
	kitchen.height = 708.50;
	kitchen.alpha = 1.00;
	if (kitchen.onLayout) kitchen.onLayout();
	const doorframe = this.doorframe;
	hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_doorframe.call(this.doorframe);
	doorframe.x = 225;
	doorframe.y = 394;
	doorframe.width = 450.00;
	doorframe.height = 748.00;
	doorframe.alpha = 1.00;
	if (doorframe.onLayout) doorframe.onLayout();
	const stairs = this.stairs;
	hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_stairs.call(this.stairs);
	stairs.x = 0;
	stairs.y = 0;
	stairs.width = 1664.00;
	stairs.height = 768.00;
	stairs.alpha = 1.00;
	if (stairs.onLayout) stairs.onLayout();
	const table = this.table;
	hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_table.call(this.table);
	table.x = 1345.25;
	table.y = 527.5;
	table.width = 637.50;
	table.height = 489.00;
	table.alpha = 1.00;
	if (table.onLayout) table.onLayout();
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_background(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_background.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_kitchen(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_kitchen) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_kitchen", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_doorframe(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_doorframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_doorframe", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_hollyback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_stairs(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_stairs) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_stairs.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_table(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_table) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_table", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p08_hollyfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframech1_p6_wcframe(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframech1_p6_wcframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p6_wcframe", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function hh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframeLayer196(this: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframeLayer196) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer196", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ihh_ch1_p08Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ihh_ch1_p08Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ihh_ch1_p08Sprite extends Ihh_ch1_p08Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ihh_ch1_p08Text extends Ihh_ch1_p08Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ihh_ch1_p08Polygon extends Array<number> {
}
interface Ihh_ch1_p08 {
	readonly hollyBack: Ihh_ch1_p08Array<Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback>;
	readonly hollyFront: Ihh_ch1_p08Array<Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront>;
	readonly frame: Ihh_ch1_p08Array<Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframech1_p6_wcframe|Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframeLayer196>;
	readonly background: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_background;
	readonly kitchen: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_kitchen;
	readonly doorframe: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_doorframe;
	readonly stairs: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_stairs;
	readonly table: Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_table;
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_background extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_kitchen extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_doorframe extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyback extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_stairs extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_table extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_hollyfront extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframech1_p6_wcframe extends Ihh_ch1_p08Sprite {
}
interface Ihh_ch1_p08_hh_ch1_72dpi_p08psdAssetP7ch1_p08_wcframeLayer196 extends Ihh_ch1_p08Sprite {
}
